import { useState, useEffect } from "react";
import {
  FaSearchPlus,
  FaSearchMinus,
  FaBarcode,
  FaRegLightbulb,
  FaLink,
  FaFont,
  FaSitemap,
} from "react-icons/fa";
import { TbCircleHalf2 } from "react-icons/tb";
import { ImEye } from "react-icons/im";
import { MdOutlineSettingsBackupRestore } from "react-icons/md";
import "../../../style/Accesibility.css";
import { NavLink } from "react-router-dom";

export default function Accesibilidad({ idComponente }) {
  const [accesbilidadSelected, setAccesbilidadSelected] = useState(0);

  const [accesbilidadStyles, setAccesbilidadStyles] = useState({
    escalaGrises: false,
    altoContraste: false,
    contrasteNegativo: false,
    subrayarEnlaces: false,
    fuenteLegible: false,
    fondoClaro: false,
  });

  const accesbilidad = {
    1: () => {
      setAccesbilidadSelected(0);

      for (const tagA of document.getElementsByTagName("a")) {
        tagA.style = "font-size: 1.3rem";
      }
      for (const tagA of document.getElementsByTagName("p")) {
        tagA.style = "font-size: 1.3rem";
      }
      for (const tagA of document.getElementsByTagName("label")) {
        tagA.style = "font-size: 1.3rem";
      }
      for (const tagA of document.getElementsByTagName("span")) {
        tagA.style = "font-size: 1.3rem";
      }
      for (const tagA of document.getElementsByTagName("h1")) {
        tagA.style = "font-size: 1.3rem";
      }
      for (const tagA of document.getElementsByTagName("h2")) {
        tagA.style = "font-size: 1.3rem";
      }
      for (const tagA of document.getElementsByTagName("h3")) {
        tagA.style = "font-size: 1.3rem";
      }
      for (const tagA of document.getElementsByTagName("h4")) {
        tagA.style = "font-size: 1.3rem";
      }
      for (const tagA of document.getElementsByTagName("h5")) {
        tagA.style = "font-size: 1.3rem";
      }
      for (const tagA of document.getElementsByTagName("h6")) {
        tagA.style = "font-size: 1.3rem";
      }
    },
    2: () => {
      setAccesbilidadSelected(0);

      for (const tagA of document.getElementsByTagName("a")) {
        tagA.style = "font-weight: normal;";

        if (tagA.id === "optionmenu") {
          tagA.style = "font-weight: 700;";
        }
      }
      for (const tagA of document.getElementsByTagName("p")) {
        tagA.style = "font-weight: unset;";
      }
      for (const tagA of document.getElementsByTagName("label")) {
        tagA.style = "font-weight: unset;";

        if (tagA.className === "lbl-titulo-result") {
          tagA.style = "font-weight: 700;";
        }

        if (tagA.className === "lbl-opciones-busqueda") {
          tagA.style = "font-weight: 700;";
        }

        if (tagA.className === "lblitulo-txt-imgbanner") {
          tagA.style = "font-weight: 800;";
        }

        if (tagA.className === "label-ayuda-descripcion") {
          tagA.style = "font-weight: 700;";
        }

        if (tagA.className === "lbl-tarjetas-app") {
          tagA.style = "font-weight: 600;";
        }

        if (tagA.className === "lbl-opendata") {
          tagA.style = "font-weight: 600;";
        }
      }
      for (const tagA of document.getElementsByTagName("span")) {
        tagA.style = "font-weight: unset;";
      }
      for (const tagA of document.getElementsByTagName("h1")) {
        tagA.style = "font-weight: unset;";
      }
      for (const tagA of document.getElementsByTagName("h2")) {
        tagA.style = "font-weight: unset;";
      }
      for (const tagA of document.getElementsByTagName("h3")) {
        tagA.style = "font-weight: unset;";
      }
      for (const tagA of document.getElementsByTagName("h4")) {
        tagA.style = "font-weight: unset;";
      }
      for (const tagA of document.getElementsByTagName("h5")) {
        tagA.style = "font-weight: unset;";
      }
      for (const tagA of document.getElementsByTagName("h6")) {
        tagA.style = "font-weight: unset;";
      }
    },
    3: () => {
      setAccesbilidadSelected(0);

      setAccesbilidadStyles((prev) => ({
        ...prev,
        escalaGrises: !prev.escalaGrises,
      }));

      !accesbilidadStyles.escalaGrises
        ? (document.getElementsByTagName("html")[0].style =
            "filter: grayscale(1);")
        : (document.getElementsByTagName("html")[0].style =
            "filter: grayscale(0);");
    },
    4: () => {
      setAccesbilidadSelected(0);

      setAccesbilidadStyles((prev) => ({
        ...prev,
        altoContraste: !prev.altoContraste,
      }));

      !accesbilidadStyles.altoContraste
        ? (document.getElementsByTagName("html")[0].style =
            "filter: brightness(80%) contrast(300%);")
        : (document.getElementsByTagName("html")[0].style = "filter: inherit");
    },
    5: () => {
      setAccesbilidadSelected(0);

      setAccesbilidadStyles((prev) => ({
        ...prev,
        contrasteNegativo: !prev.contrasteNegativo,
      }));

      !accesbilidadStyles.contrasteNegativo
        ? (document.getElementsByTagName("html")[0].style =
            "filter: invert(1);")
        : (document.getElementsByTagName("html")[0].style =
            "filter: invert(0);");
    },
    6: () => {
      setAccesbilidadSelected(0);

      setAccesbilidadStyles((prev) => ({
        ...prev,
        fondoClaro: !prev.fondoClaro,
      }));

      if (!accesbilidadStyles.fondoClaro) {
        document.querySelector(".barra-gov").style = "background-color:#fff;";
        document.querySelector(".delete-efectobotones").style = "color:#000;";
        document.querySelector("#button-register_nav").style = "color:#000;";
        document.querySelector("#user-or_initSesion").style = "color:#000;";
        if (idComponente !== 0) {
          document.querySelector(".barra2").style = "background-color:#fff;";
        }
      } else {
        document.querySelector(".barra-gov").style =
          "background-color:#376ac9;";
        document.querySelector(".delete-efectobotones").style = "color:#fff;";

        document.querySelector("#button-register_nav").style = "color:#fff;";
        document.querySelector("#user-or_initSesion").style = "color:#fff;";

        if (idComponente !== 0) {
          document.querySelector(".barra2").style = "background-color:#e6effd;";
        }
      }
    },
    7: () => {
      setAccesbilidadSelected(0);

      setAccesbilidadStyles((prev) => ({
        ...prev,
        subrayarEnlaces: !prev.subrayarEnlaces,
      }));

      if (!accesbilidadStyles.subrayarEnlaces) {
        for (const tagA of document.getElementsByTagName("a")) {
          tagA.style = "text-decoration: underline;";
        }
      } else {
        for (const tagA of document.getElementsByTagName("a")) {
          tagA.style = "text-decoration: none;";
        }
      }
    },
    8: () => {
      setAccesbilidadSelected(0);

      setAccesbilidadStyles((prev) => ({
        ...prev,
        fuenteLegible: !prev.fuenteLegible,
      }));

      if (!accesbilidadStyles.fuenteLegible) {
        for (const tagA of document.getElementsByTagName("a")) {
          tagA.style = "font-weight: bold";
        }
        for (const tagA of document.getElementsByTagName("p")) {
          tagA.style = "font-weight: bold";
        }
        for (const tagA of document.getElementsByTagName("label")) {
          tagA.style = "font-weight: bold";
        }
        for (const tagA of document.getElementsByTagName("span")) {
          tagA.style = "font-weight: bold";
        }
        for (const tagA of document.getElementsByTagName("h1")) {
          tagA.style = "font-weight: bold";
        }
        for (const tagA of document.getElementsByTagName("h2")) {
          tagA.style = "font-weight: bold";
        }
        for (const tagA of document.getElementsByTagName("h3")) {
          tagA.style = "font-weight: bold";
        }
        for (const tagA of document.getElementsByTagName("h4")) {
          tagA.style = "font-weight: bold";
        }
        for (const tagA of document.getElementsByTagName("h5")) {
          tagA.style = "font-weight: bold";
        }
        for (const tagA of document.getElementsByTagName("h6")) {
          tagA.style = "font-weight: bold";
        }
      } else {
        for (const tagA of document.getElementsByTagName("a")) {
          tagA.style = "text-decoration: none;";
        }
        for (const tagA of document.getElementsByTagName("a")) {
          tagA.style = "font-weight: normal;";

          if (tagA.className === "content-retroceder") {
            window.scrollY > 0
              ? (tagA.style = "display:none;")
              : (tagA.style = "display:block;");
          }

          if (tagA.id === "optionmenu") {
            tagA.style = "font-weight: 700;";
          }
        }
        for (const tagA of document.getElementsByTagName("p")) {
          tagA.style = "font-weight: normal;";
        }
        for (const tagA of document.getElementsByTagName("label")) {
          tagA.style = "font-weight: normal;";

          if (tagA.className === "lbl-titulo-result") {
            tagA.style = "font-weight: 700;";
          }

          if (tagA.className === "lbl-opciones-busqueda") {
            tagA.style = "font-weight: 700;";
          }

          if (tagA.className === "lblitulo-txt-imgbanner") {
            tagA.style = "font-weight: 800;";
          }

          if (tagA.className === "label-ayuda-descripcion") {
            tagA.style = "font-weight: 700;";
          }

          if (tagA.className === "lbl-tarjetas-app") {
            tagA.style = "font-weight: 600;";
          }

          if (tagA.className === "lbl-opendata") {
            tagA.style = "font-weight: 600;";
          }
        }
        for (const tagA of document.getElementsByTagName("span")) {
          tagA.style = "font-weight: normal;";
        }
        for (const tagA of document.getElementsByTagName("h1")) {
          tagA.style = "font-weight: normal;";
        }
        for (const tagA of document.getElementsByTagName("h2")) {
          tagA.style = "font-weight: normal;";
        }
        for (const tagA of document.getElementsByTagName("h3")) {
          tagA.style = "font-weight: normal;";
        }
        for (const tagA of document.getElementsByTagName("h4")) {
          tagA.style = "font-weight: normal;";
        }
        for (const tagA of document.getElementsByTagName("h5")) {
          tagA.style = "font-weight: normal;";
        }
        for (const tagA of document.getElementsByTagName("h6")) {
          tagA.style = "font-weight: normal;";
        }
      }
    },
    9: () => {
      setAccesbilidadSelected(0);

      setAccesbilidadStyles({
        escalaGrises: false,
        altoContraste: false,
        contrasteNegativo: false,
        subrayarEnlaces: false,
        fuenteLegible: false,
      });

      document.getElementsByTagName("html")[0].style = "filter: grayscale(0);";
      document.getElementsByTagName("html")[0].style = "filter: grayscale(0);";
      document.getElementsByTagName("html")[0].style = "filter: inherit";

      for (const tagA of document.getElementsByTagName("a")) {
        tagA.style = "text-decoration: none;";
      }
      for (const tagA of document.getElementsByTagName("a")) {
        tagA.style = "font-weight: normal;";

        if (tagA.className === "content-retroceder") {
          window.scrollY > 0
            ? (tagA.style = "display:none;")
            : (tagA.style = "display:block;");
        }

        if (tagA.id === "optionmenu") {
          tagA.style = "font-weight: 700;";
        }
      }
      for (const tagA of document.getElementsByTagName("p")) {
        tagA.style = "font-weight: normal;";
      }
      for (const tagA of document.getElementsByTagName("label")) {
        tagA.style = "font-weight: normal;";

        if (tagA.className === "lbl-titulo-result") {
          tagA.style = "font-weight: 700;";
        }

        if (tagA.className === "lbl-opciones-busqueda") {
          tagA.style = "font-weight: 700;";
        }

        if (tagA.className === "label-ayuda-descripcion") {
          tagA.style = "font-weight: 700;";
        }

        if (tagA.className === "lblitulo-txt-imgbanner") {
          tagA.style = "font-weight: 800;";
        }

        if (tagA.className === "lbl-tarjetas-app") {
          tagA.style = "font-weight: 600;";
        }

        if (tagA.className === "lbl-opendata") {
          tagA.style = "font-weight: 600;";
        }
      }
      for (const tagA of document.getElementsByTagName("span")) {
        tagA.style = "font-weight: normal;";
      }
      for (const tagA of document.getElementsByTagName("h1")) {
        tagA.style = "font-weight: normal;";
      }
      for (const tagA of document.getElementsByTagName("h2")) {
        tagA.style = "font-weight: normal;";
      }
      for (const tagA of document.getElementsByTagName("h3")) {
        tagA.style = "font-weight: normal;";
      }
      for (const tagA of document.getElementsByTagName("h4")) {
        tagA.style = "font-weight: normal;";
      }
      for (const tagA of document.getElementsByTagName("h5")) {
        tagA.style = "font-weight: normal;";
      }
      for (const tagA of document.getElementsByTagName("h6")) {
        tagA.style = "font-weight: normal;";
      }
    },
  };

  useEffect(() => {
    const funcionAccesbilidad = accesbilidad[accesbilidadSelected];

    if (accesbilidadSelected !== 0) {
      funcionAccesbilidad();
    }
  }, [accesbilidadSelected]);

  useEffect(() => {
    setAccesbilidadStyles({
      escalaGrises: false,
      altoContraste: false,
      contrasteNegativo: false,
      subrayarEnlaces: false,
      fuenteLegible: false,
      fondoClaro: false,
    });
  }, [idComponente]);

  const [collapse, setCollapse] = useState(false); //estado hidden del collaps de opciones de accesibilidad
  return (
    <>
      <nav
        id="pojo-a11y-toolbar"
        className={
          collapse
            ? "pojo-a11y-toolbar-left pojo-a11y-toolbar-open top-accesible"
            : "pojo-a11y-toolbar-left top-accesible"
        }
        role="navigation"
      >
        <div
          className="pojo-a11y-toolbar-toggle boton-accesible"
          onClick={() => {
            collapse ? setCollapse(false) : setCollapse(true);
          }}
        >
          <a
            className="pojo-a11y-toolbar-link pojo-a11y-toolbar-toggle-link"
            href="##"
            title="Accesibilidad"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 100 100"
              fill="currentColor"
              width="1em"
            >
              <path d="M50 8.1c23.2 0 41.9 18.8 41.9 41.9 0 23.2-18.8 41.9-41.9 41.9C26.8 91.9 8.1 73.2 8.1 50S26.8 8.1 50 8.1M50 0C22.4 0 0 22.4 0 50s22.4 50 50 50 50-22.4 50-50S77.6 0 50 0zm0 11.3c-21.4 0-38.7 17.3-38.7 38.7S28.6 88.7 50 88.7 88.7 71.4 88.7 50 71.4 11.3 50 11.3zm0 8.9c4 0 7.3 3.2 7.3 7.3S54 34.7 50 34.7s-7.3-3.2-7.3-7.3 3.3-7.2 7.3-7.2zm23.7 19.7c-5.8 1.4-11.2 2.6-16.6 3.2.2 20.4 2.5 24.8 5 31.4.7 1.9-.2 4-2.1 4.7-1.9.7-4-.2-4.7-2.1-1.8-4.5-3.4-8.2-4.5-15.8h-2c-1 7.6-2.7 11.3-4.5 15.8-.7 1.9-2.8 2.8-4.7 2.1-1.9-.7-2.8-2.8-2.1-4.7 2.6-6.6 4.9-11 5-31.4-5.4-.6-10.8-1.8-16.6-3.2-1.7-.4-2.8-2.1-2.4-3.9.4-1.7 2.1-2.8 3.9-2.4 19.5 4.6 25.1 4.6 44.5 0 1.7-.4 3.5.7 3.9 2.4.7 1.8-.3 3.5-2.1 3.9z"></path>{" "}
            </svg>
          </a>
        </div>
        <div className="pojo-a11y-toolbar-overlay">
          <div className="pojo-a11y-toolbar-inner">
            <p className="pojo-a11y-toolbar-title">Accesibilidad</p>
            <ul className="pojo-a11y-toolbar-items pojo-a11y-tools">
              <li
                className="pojo-a11y-toolbar-item"
                onClick={() => {
                  setAccesbilidadSelected(1);
                }}
              >
                <a
                  href="##"
                  className="opciones-accesibilidad pojo-a11y-toolbar-link pojo-a11y-btn-resize-font pojo-a11y-btn-resize-plus"
                  data-action="resize-plus"
                  data-action-group="resize"
                >
                  <span className="pojo-a11y-toolbar-icon">
                    <FaSearchPlus />
                  </span>
                  <span className="pojo-a11y-toolbar-text">Aumentar texto</span>
                </a>
              </li>

              <li
                className="pojo-a11y-toolbar-item"
                onClick={() => {
                  setAccesbilidadSelected(2);
                }}
              >
                <a
                  href="##"
                  className=" opciones-accesibilidad pojo-a11y-toolbar-link pojo-a11y-btn-resize-font pojo-a11y-btn-resize-minus"
                  data-action="resize-minus"
                  data-action-group="resize"
                >
                  <span className="pojo-a11y-toolbar-icon">
                    <FaSearchMinus />
                  </span>
                  <span className="pojo-a11y-toolbar-text">
                    Disminuir texto
                  </span>
                </a>
              </li>

              <li
                className="pojo-a11y-toolbar-item"
                onClick={() => {
                  setAccesbilidadSelected(3);
                }}
              >
                <a
                  href="##"
                  className="opciones-accesibilidad pojo-a11y-toolbar-link pojo-a11y-btn-background-group pojo-a11y-btn-grayscale"
                  data-action="grayscale"
                  data-action-group="schema"
                >
                  <span className="pojo-a11y-toolbar-icon">
                    <FaBarcode />
                  </span>
                  <span className="pojo-a11y-toolbar-text">
                    Escala de grises
                  </span>
                </a>
              </li>

              <li
                className="pojo-a11y-toolbar-item"
                onClick={() => {
                  setAccesbilidadSelected(4);
                }}
              >
                <a
                  href="##"
                  className="opciones-accesibilidad pojo-a11y-toolbar-link pojo-a11y-btn-background-group pojo-a11y-btn-high-contrast"
                  data-action="high-contrast"
                  data-action-group="schema"
                >
                  <span className="pojo-a11y-toolbar-icon">
                    <TbCircleHalf2 />
                  </span>
                  <span className="pojo-a11y-toolbar-text">Alto contraste</span>
                </a>
              </li>

              <li
                className="pojo-a11y-toolbar-item"
                onClick={() => {
                  setAccesbilidadSelected(5);
                }}
              >
                <a
                  href="##"
                  className="opciones-accesibilidad pojo-a11y-toolbar-link pojo-a11y-btn-background-group pojo-a11y-btn-negative-contrast"
                  data-action="negative-contrast"
                  data-action-group="schema"
                >
                  <span className="pojo-a11y-toolbar-icon">
                    <ImEye />
                  </span>
                  <span className="pojo-a11y-toolbar-text">
                    Contraste negativo
                  </span>
                </a>
              </li>

              {/* <li
                className="pojo-a11y-toolbar-item"
                onClick={() => {
                  setAccesbilidadSelected(6);
                }}
              >
                <a
                  href="##"
                  className="opciones-accesibilidad pojo-a11y-toolbar-link pojo-a11y-btn-background-group pojo-a11y-btn-light-background"
                  data-action="light-background"
                  data-action-group="schema"
                >
                  <span className="pojo-a11y-toolbar-icon">
                    <FaRegLightbulb />
                  </span>
                  <span className="pojo-a11y-toolbar-text">Fondo claro</span>
                </a>
              </li> */}

              <li
                className="pojo-a11y-toolbar-item"
                onClick={() => {
                  setAccesbilidadSelected(7);
                }}
              >
                <a
                  href="##"
                  className="opciones-accesibilidad pojo-a11y-toolbar-link pojo-a11y-btn-links-underline"
                  data-action="links-underline"
                  data-action-group="toggle"
                >
                  <span className="pojo-a11y-toolbar-icon">
                    <FaLink />
                  </span>
                  <span className="pojo-a11y-toolbar-text">
                    Subrayar enlaces
                  </span>
                </a>
              </li>

              <li
                className="pojo-a11y-toolbar-item"
                onClick={() => {
                  setAccesbilidadSelected(8);
                }}
              >
                <a
                  href="##"
                  className="opciones-accesibilidad pojo-a11y-toolbar-link pojo-a11y-btn-readable-font"
                  data-action="readable-font"
                  data-action-group="toggle"
                >
                  <span className="pojo-a11y-toolbar-icon">
                    <FaFont />
                  </span>
                  <span className="pojo-a11y-toolbar-text">Fuente legible</span>
                </a>
              </li>
              <li
                className="pojo-a11y-toolbar-item"
                onClick={() => {
                  setAccesbilidadSelected(9);
                }}
              >
                <a
                  href="##"
                  className="opciones-accesibilidad pojo-a11y-toolbar-link pojo-a11y-btn-reset"
                  data-action="reset"
                >
                  <span className="pojo-a11y-toolbar-icon">
                    <MdOutlineSettingsBackupRestore />
                  </span>
                  <span className="pojo-a11y-toolbar-text">Restablecer</span>
                </a>
              </li>
            </ul>
            <ul className="pojo-a11y-toolbar-items pojo-a11y-links divisor">
              <NavLink
                to={"/mapaNavegacion"}
                className="pojo-a11y-toolbar-item"
              >
                <a
                  href="##"
                  className="opciones-accesibilidad pojo-a11y-toolbar-link pojo-a11y-link-sitemap"
                >
                  <span className="pojo-a11y-toolbar-icon">
                    <FaSitemap />
                  </span>
                  <span className="pojo-a11y-toolbar-text ms-2">
                    Mapa del sitio
                  </span>
                </a>
              </NavLink>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}
